import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
class ListVisitScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logRoutes: [],
      hasMore: false,
      page: 1,
      totalPage: 0,
      perPageItem: 20,
    };
  }
  componentDidMount() {
    this.fetchData(1);
  }

  fetchData = async (activePage) => {
    const data = await API(this, "get", URL_PATH.visitList(activePage));
    const { logRoutes, page, totalPage, perPageItem, hasMore } = data;
    this.setState({
      logRoutes,
      totalPage,
      hasMore,
      page: parseInt(page),
      // page,
      // perPageItem,
    });
  };
  pageNumbers = (page, totalPages) => {
    let pageNumbers = [];
    const startIndex = page > 10 ? page - 10 : 1;
    const endIndex = page + 10 < totalPages ? page + 10 : totalPages;
    for (let i = startIndex; i <= endIndex; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers.map((number) => (
      <li
        className="page-item"
        onClick={() => {
          this.fetchData(number);
        }}
      >
        <a
          className="page-link"
          style={{
            backgroundColor: page == number ? "#121212" : "white",
            color: page == number ? "white" : "black",
          }}
          href="#"
        >
          {number}
        </a>
      </li>
    ));
  };
  render() {
    const { logRoutes, page, totalPage, perPageItem } = this.state;

    return (
      <div className="container">
        <h1>Visits</h1>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Id</th>
              <th>Method</th>
              <th>URI</th>
              <th>Name</th>
              {/* <th>Action</th> */}
              <th>IP</th>
              <th>Created At</th>
              <th>Updated At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {logRoutes.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.method}</td>
                <td>{item.uri}</td>
                <td>{item.name}</td>
                {/* <td>{item.action}</td> */}
                <td>{item.ip}</td>
                <td>{item.created_at}</td>
                <td>{item.updated_at}</td>
                <td>
                  {/* <Link
                                        to={routes.admin.franchise.show(
                                            item.id
                                        )}
                                        className="btn btn-primary m-1"
                                    >
                                        Show
                                    </Link>
                                    <Link
                                        to={routes.admin.franchise.update(
                                            item.id
                                        )}
                                        className="btn btn-primary m-1"
                                    >
                                        Edit
                                    </Link> */}
                  <Link
                    to={routes.admin.gallery.delete(item.id)}
                    className="btn btn-danger m-1"
                  >
                    Delete
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* pages */}

        <nav aria-label="Page navigation example">
          <ul className="pagination container justify-content-center">
            <li className="page-item">
              <a className="page-link" href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span className="sr-only">Previous</span>
              </a>
            </li>
            {this.pageNumbers(page, totalPage)}
            <li className="page-item">
              <a className="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span className="sr-only">Next</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default redux(ListVisitScreen);
